import { useEffect, useState } from 'react';
import { api } from '@/api/client';

interface Wrapper {
  id: string;
  name: string;
  displayName: string;
  description?: string;
  intentWeight?: number;
  enabled?: boolean;
  toolIds?: string[];
}

export function Brain() {
  const [wrappers, setWrappers] = useState<Wrapper[] | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    api
      .get<{ data: Wrapper[] }>('/api/admin/wrappers')
      .then((r) => setWrappers(r.data))
      .catch((e) => setErr((e as Error).message));
  }, []);

  return (
    <div>
      <h1 style={{ marginTop: 0 }}>Brain</h1>
      <p style={{ color: '#9ca3af', maxWidth: 640 }}>
        Wrappers are the per-domain personas Breww picks between when it routes a prompt.
        This page shows the current catalog.
      </p>

      {err && (
        <div style={{
          marginTop: '1rem', padding: '0.75rem 1rem', borderRadius: 6,
          background: 'rgba(239, 68, 68, 0.12)', border: '1px solid rgba(239, 68, 68, 0.35)', color: '#fca5a5',
        }}>{err}</div>
      )}

      {wrappers === null && !err && (
        <p style={{ marginTop: '1.5rem', color: '#9ca3af' }}>Loading wrappers…</p>
      )}

      {wrappers && (
        <div style={{ marginTop: '1.5rem', overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
        <table style={{ width: '100%', minWidth: 480, borderCollapse: 'collapse', fontSize: '0.9rem' }}>
          <thead>
            <tr style={{ textAlign: 'left', color: '#9ca3af', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              <th style={{ padding: '0.5rem 0.75rem' }}>Name</th>
              <th style={{ padding: '0.5rem 0.75rem' }}>Display name</th>
              <th style={{ padding: '0.5rem 0.75rem' }}>Tools</th>
              <th style={{ padding: '0.5rem 0.75rem' }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {wrappers.map((w) => (
              <tr key={w.id} style={{ borderTop: '1px solid rgba(127, 127, 127, 0.15)' }}>
                <td style={{ padding: '0.65rem 0.75rem', fontFamily: 'monospace' }}>{w.name}</td>
                <td style={{ padding: '0.65rem 0.75rem' }}>{w.displayName && w.displayName.startsWith('Brew') ? w.displayName.replace(/^Brew/, 'Breww') : w.displayName}</td>
                <td style={{ padding: '0.65rem 0.75rem', color: '#9ca3af' }}>{w.toolIds?.length ?? 0}</td>
                <td style={{ padding: '0.65rem 0.75rem' }}>
                  <span style={{
                    fontSize: '0.7rem', padding: '2px 8px', borderRadius: 999,
                    background: w.enabled ? 'rgba(16, 185, 129, 0.18)' : 'rgba(127, 127, 127, 0.18)',
                    color: w.enabled ? '#34d399' : '#9ca3af',
                    textTransform: 'uppercase', letterSpacing: '0.04em', fontWeight: 600,
                  }}>{w.enabled ? 'on' : 'off'}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      )}
    </div>
  );
}
